import { mediaUrl } from "@/lib/api";

export const Wordmark = ({ size = "sm", testId }) => (
  <span
    data-testid={testId}
    className={`font-display leading-none text-[#F4EFE6] ${size === "lg" ? "text-6xl sm:text-7xl lg:text-8xl" : "text-2xl sm:text-3xl"}`}
  >
    JIMMY<span className="text-[#FFD23F]">Z</span> RESTOZ
  </span>
);

export const Logo = ({ logo, size = "sm", testId = "site-logo" }) => {
  if (!logo?.url) return <Wordmark size={size} testId={`${testId}-wordmark`} />;
  const cls = size === "lg" ? "w-full max-w-[460px] h-auto" : "h-10 sm:h-12 w-auto";
  return (
    <img
      src={mediaUrl(logo.url)}
      alt="Jimmyz Restoz logo"
      width={logo.width || undefined}
      height={logo.height || undefined}
      className={`${cls} object-contain ${size === "lg" ? "drop-shadow-[0_10px_24px_rgba(0,0,0,0.55)]" : ""}`}
      data-testid={testId}
    />
  );
};
